import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Session, UsuarioAcceso, UsuarioDarAvisoExpiracionClave, UsuarioExpiracionClave } from 'src/app/session/store/session';
import { map, catchError, timeout, delay } from 'rxjs/operators';
import { of, TimeoutError, Observable } from 'rxjs';
import { NotificacionBundle } from 'src/common/notificacionBundle';
import { Voxintar } from '../shared/voxintar';

@Injectable()
export class SessionService {

	private readonly USUARIO_ACCESO_URL: string = environment.backendUrl + '/usuario/acceso';
	private readonly SESSION_IPI_URL: string = environment.backendUrl + '/usuario/sesion-ipi';
	private readonly SESSION_TOKEN_URL: string = environment.backendUrl + '/usuario/sesion-token';
	private readonly REFRESH_LEGACY_SESSION_URL: string = environment.legacyControlSesionBaseUrl + '/control-session/intranet_session.php';
	private readonly SERVER_DATE: string = environment.backendUrl + '/admin/date'
	private readonly POSPONER_PROX_AVISO_URL: string = environment.backendUrl + '/usuario/clave/proximo-aviso';
	private readonly CAMBIAR_CLAVE_URL: string = environment.backendUrl + '/usuario/clave';
	private readonly SESSION_URL: string = environment.backendUrl + '/usuario/sesion';

	private readonly INTERNAL_SERVER_ERROR: number = 500;


	constructor( private http: HttpClient, private voxintar: Voxintar ) {
	}

	createUsuarioAcceso( ipi: number, ps: string, ce: string, se: string ): Observable<UsuarioAcceso> {
		return this.http.post<UsuarioAcceso>( this.USUARIO_ACCESO_URL, { ipi, ps, ce, se } );
	}

	createSessionFromIPI( idPersonaInstitucional: number ): Observable<Session> {
		return this.http.post<Session>( this.SESSION_IPI_URL, { idPersonaInstitucional } );
	}

	createSessionFromToken(): Observable<Session> {
		return this.http.post<Session>( this.SESSION_TOKEN_URL, {} );
	}

	deleteSession(): Observable<void> {
		return this.http.delete<void>( this.SESSION_URL );
	}

	refreshLegacySession( session: string ): Observable<boolean> {
		return this.http.post( this.REFRESH_LEGACY_SESSION_URL, { session } ).pipe(
			timeout( 3000 ),
			map( data => {
				return true;
			}),
			catchError( error => {
				let isValidSession: boolean = false;
				if( ( error instanceof HttpErrorResponse && error.status == this.INTERNAL_SERVER_ERROR ) || error instanceof TimeoutError )
					isValidSession = true;
				return of( isValidSession );
			})
		);
	}

	getServerDate(): Observable<NotificacionBundle<Date>> {
		return this.http.get<NotificacionBundle<Date>>( this.SERVER_DATE );
	}

	posponerAvisoExpiracionClave(): Observable<UsuarioDarAvisoExpiracionClave> {
		return this.http.put<UsuarioDarAvisoExpiracionClave>( this.POSPONER_PROX_AVISO_URL, null );
	}

	cambiarClave( claveActual: string, claveNueva: string ): Observable<UsuarioExpiracionClave> {
		claveActual = this.voxintar.inari( claveActual );
		claveNueva = this.voxintar.inari( claveNueva );
		return this.http.put<UsuarioExpiracionClave>( this.CAMBIAR_CLAVE_URL, { claveActual, claveNueva } );
	}

}